__turbopack_context__.v({
  "big": "Cs1PIW_big",
  "contact-form": "Cs1PIW_contact-form",
  "contact-header": "Cs1PIW_contact-header",
  "container": "Cs1PIW_container",
  "form-section": "Cs1PIW_form-section",
  "form-submitted": "Cs1PIW_form-submitted",
  "hero-reveal": "Cs1PIW_hero-reveal",
  "inputs": "Cs1PIW_inputs",
  "section-title": "Cs1PIW_section-title",
  "small": "Cs1PIW_small",
  "subtitle": "Cs1PIW_subtitle",
  "success-text": "Cs1PIW_success-text",
});
